import { createFileRoute } from '@tanstack/react-router'

import { CustomerDetail } from '@/features/customers/customer-detail'
import { customerRecordSearchSchema } from '@/features/customers/record-search'

export const Route = createFileRoute('/_app/customers/$customerId')({
  validateSearch: (search) => customerRecordSearchSchema.parse(search),
  component: CustomerDetail,
})
